import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a81a23e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a81a23e4&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81a23e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a81a23e4')) {
      api.createRecord('a81a23e4', component.options)
    } else {
      api.reload('a81a23e4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a81a23e4&scoped=true", function () {
      api.rerender('a81a23e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/userProfile/index.vue"
export default component.exports